(function () {
  function injectShopifyFormStyles() {
    const embeds = document.querySelectorAll('shopify-forms-embed');

    embeds.forEach((embed) => {
      const root = embed.shadowRoot;

      if (!root) return;

      const oldStyle = root.querySelector('#custom-shopify-forms-style');
      if (oldStyle) oldStyle.remove();

      const style = document.createElement('style');
      style.id = 'custom-shopify-forms-style';

      style.textContent = `
        :host {
          /*
            Let the app fill the available theme page-width.
            Do NOT set container background/radius here,
            because that creates Shopify's extra inner box.
          */
          --container-max-w: 100% !important;
          --inline-container-max-width: 100% !important;
          --app-embed-width: 100% !important;

          /*
            Button color
          */
          --button-background-color: var(--okko-form-button) !important;
          --button-text-color: var(--okko-inverse) !important;
          --button-border-radius: calc(6px * var(--okko-radius-scale)) !important;

          /*
            Text colors.
          */
          --body-text-color: var(--okko-tone-202020) !important;
          --form-text-color: var(--okko-tone-202020) !important;
          --heading-text-color: var(--okko-tone-202020) !important;
          --link-text-color: var(--okko-tone-202020) !important;
        }

        /*
          OUTER WHITE CARD
          This should become as wide as the normal page width.
        */
        section[role="dialog"] {
          width: 100% !important;
          max-width: none !important;
          background: var(--okko-surface) !important;
          border-radius: calc(10px * var(--okko-radius-scale)) !important;
          padding: calc(48px * var(--okko-spacing-scale)) calc(64px * var(--okko-spacing-scale)) !important;
          box-sizing: border-box !important;
          color: var(--okko-tone-202020) !important;
          overflow: hidden !important;
        }

        /*
          Make Shopify's layout wrappers fill the card.
        */
        div[data-sizing="form-wrapper"],
        section[class*="inline"],
        div[class*="container"],
        div[class*="grid"] {
          width: 100% !important;
          max-width: none !important;
        }

        /*
          INNER CONTENT WIDTH
          This keeps fields/text at the width you already like,
          while the white card itself is wider.
        */
        div[class*="gridItemContent"] {
          width: 100% !important;
          max-width: 720px !important;
          margin-left: auto !important;
          margin-right: auto !important;
          box-sizing: border-box !important;
        }

        /*
          Keep Shopify fields untouched.
          Only make spacing a little nicer.
        */
        form,
        [data-testid="form"] {
          width: 100% !important;
          gap: calc(20px * var(--okko-spacing-scale)) !important;
        }

        /*
          Text readability.
        */
        p, label, legend, input, textarea, select {
          font-family: var(--font-body-family) !important;
          font-style: var(--font-body-style) !important;
        }

        h2,
        p,
        label,
        legend,
        span {
          color: var(--okko-tone-202020) !important;
        }

        h2 {
            font-size: var(--okko-heading-42) !important;
            font-family: var(--font-heading-family) !important;
            font-style: var(--font-heading-style) !important;
            font-weight: var(--font-heading-weight) !important;
            letter-spacing: var(--font-heading-letter-spacing) !important;
            text-transform: var(--font-heading-transform) !important;
            margin-bottom: calc(25px * var(--okko-spacing-scale)) !important;
        }

        section[class*="formHeader"] {
          margin-bottom: calc(32px * var(--okko-spacing-scale)) !important;
        }

        /*
          Submit button 
        */
        button[type="submit"] {
          font-family: var(--font-button-family) !important;
          
          background: var(--okko-form-button) !important;
          color: var(--okko-inverse) !important;
          border-radius: calc(6px * var(--okko-radius-scale)) !important;
          border: 0 !important;
        }

        button[type="submit"]:hover {
          background: var(--okko-form-button-hover) !important;
        }

        @media only screen and (max-width: 600px) {
          section[role="dialog"] {
            padding: calc(32px * var(--okko-spacing-scale)) calc(22px * var(--okko-spacing-scale)) !important;
            border-radius: calc(12px * var(--okko-radius-scale)) !important;
          }

          div[class*="gridItemContent"] {
            max-width: 100% !important;
          }

          form,
          [data-testid="form"] {
            gap: calc(16px * var(--okko-spacing-scale)) !important;
          }

          h2 {
            font-size: var(--okko-heading-22) !important;
          }
        }
      `;

      root.appendChild(style);
    });
  }

  injectShopifyFormStyles();

  const observer = new MutationObserver(injectShopifyFormStyles);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();